import { ThunkAction } from "redux-thunk";
import { RootState } from "../reducer";
import { ActionType } from "../reducer/types";
import { REQUEST_COMPLETED, REQUEST_STARTED } from "./application";
import { post } from "./api";
import config from "../../config";
import { SET_SESSION_TIMEOUT_ERROR, setSessionTimeoutError } from "./login";

export const SET_REPORT = "SET_REPORT";

export const SET_START_DATE = "SET_START_DATE";
export const SET_END_DATE = "SET_END_DATE";
export const SET_PROJECT_NAME = "SET_PROJECT_NAME";
export const SET_DATE_RANGE = "SET_DATE_RANGE";

export const getReports =
  (body: any): ThunkAction<void, RootState, unknown, ActionType> =>
  async (dispatch) => {
    return new Promise(
      async (resolve: (x: any) => void, reject: (x: any) => void) => {
        dispatch({ type: REQUEST_STARTED });
        //Call API
        const result = await post(`${config.BASE_URL}/report`, body);
        console.log("Verification Application Deatil result", result);
        dispatch({ type: SET_REPORT, payload: result });
        resolve(result);
        dispatch({ type: REQUEST_COMPLETED });
      }
    );
  };

export const getReportsByLocation =
  (body: any): ThunkAction<void, RootState, unknown, ActionType> =>
  async (dispatch) => {
    return new Promise(
      async (resolve: (x: any) => void, reject: (x: any) => void) => {
        try {
          dispatch({ type: REQUEST_STARTED });
          //Call API
          const result = await post(
            `${config.BASE_URL}/reportByLocation`,
            body
          );
          console.log("Verification Application Deatil result", result);
          dispatch({ type: SET_REPORT, payload: result });
          dispatch({ type: REQUEST_COMPLETED });
          resolve(result);
        } catch (error:any) {
          console.log("Error", error.response);
          await dispatch({ type: REQUEST_COMPLETED });
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.details
          ) {
            if (
              error.response.data.details.indexOf("No refresh token is set") !=
              -1
            ) {
              dispatch(setSessionTimeoutError(true));
            } else {
              alert(error.response.data.details);
            }
          }
          console.log("error.response.data.details", error.response);
        }
      }
    );
  };

export const getZalesReportsByLocation =
  (
    body: any,
    showProgress: boolean = true
  ): ThunkAction<void, RootState, unknown, ActionType> =>
  async (dispatch) => {
    return new Promise(
      async (resolve: (x: any) => void, reject: (x: any) => void) => {
        try {
          if (showProgress) {
            dispatch({ type: REQUEST_STARTED });
          }

          //Call API
          const result = await post(
            `${config.BASE_URL}/zales/reportByLocationZales`,
            body
          );
          console.log("Verification Application Deatil result", result);
          dispatch({ type: SET_REPORT, payload: result });
          if (showProgress) {
            dispatch({ type: REQUEST_COMPLETED });
          }
          resolve(result);
        } catch (error:any) {
          console.log("Error", error.response);
          if (showProgress) {
            await dispatch({ type: REQUEST_COMPLETED });
          }
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.details
          ) {
            if (
              error.response.data.details.indexOf("No refresh token is set") !=
              -1
            ) {
              dispatch(setSessionTimeoutError(true));
            } else {
              alert(error.response.data.details);
            }
          }
          console.log("error.response.data.details", error.response);
        }
      }
    );
  };

export const getZalesBigQueryReport =
  (body: any): ThunkAction<void, RootState, unknown, ActionType> =>
  async (dispatch) => {
    return new Promise(
      async (resolve: (x: any) => void, reject: (x: any) => void) => {
        try {
          dispatch({ type: REQUEST_STARTED });
          //Call API
          const result = await post(`${config.BASE_URL}/zales/getData`, body);
          // console.log("Verification Application Deatil result", result);
          dispatch({ type: SET_REPORT, payload: result });
          dispatch({ type: REQUEST_COMPLETED });
          resolve(result);
        } catch (error:any) {
          console.log("Error", error.response);
          await dispatch({ type: REQUEST_COMPLETED });
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.details
          ) {
            if (
              error.response.data.details.indexOf("No refresh token is set") !=
              -1
            ) {
              dispatch(setSessionTimeoutError(true));
            } else {
              alert(error.response.data.details);
            }
          }
          console.log("error.response.data.details", error.response);
        }
      }
    );
  };

export const runQuery =
  (
    body: any
    // showProgress: boolean = true
  ): ThunkAction<void, RootState, unknown, ActionType> =>
  async (dispatch) => {
    return new Promise(
      async (resolve: (x: any) => void, reject: (x: any) => void) => {
        try {
          dispatch({ type: REQUEST_STARTED });

          //Call API
          const result = await post(`${config.BASE_URL}/zales/runQuery`, body)
            // .then()
            .catch((err) => {
              reject(err);
            });
          dispatch({ type: SET_REPORT, payload: result });
          dispatch({ type: REQUEST_COMPLETED });
          resolve(result);
        } catch (error:any) {
          console.log("Error", error.response);
          await dispatch({ type: REQUEST_COMPLETED });
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.details
          ) {
            if (
              error.response.data.details.indexOf("No refresh token is set") !=
              -1
            ) {
              dispatch(setSessionTimeoutError(true));
            } else {
              alert(error.response.data.details);
            }
          }
          console.log("error.response.data.details", error.response);
        }
      }
    );
  };

export const runQueryKJ =
  (
    body: any,
    showProgress: boolean = true
  ): ThunkAction<void, RootState, unknown, ActionType> =>
  async (dispatch) => {
    return new Promise(
      async (resolve: (x: any) => void, reject: (x: any) => void) => {
        try {
          // console.log("showProgress", showProgress);
          dispatch({ type: REQUEST_STARTED });
          //Call API
          const result = await post(`${config.BASE_URL}/Kay/runQuery`, body);
          // console.log("Verification Application Deatil result", result);
          dispatch({ type: SET_REPORT, payload: result });
          dispatch({ type: REQUEST_COMPLETED });
          resolve(result);
        } catch (error:any) {
          console.log("Error", error.response);
          dispatch({ type: REQUEST_COMPLETED });
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.details
          ) {
            if (
              error.response.data.details.indexOf("No refresh token is set") !=
              -1
            ) {
              dispatch(setSessionTimeoutError(true));
            } else {
              alert(error.response.data.details);
            }
          }
          console.log("error.response.data.details", error.response);
        }
      }
    );
  };

export const runQueryPagoda =
  (
    body: any,
    showProgress: boolean = true
  ): ThunkAction<void, RootState, unknown, ActionType> =>
  async (dispatch) => {
    return new Promise(
      async (resolve: (x: any) => void, reject: (x: any) => void) => {
        try {
          dispatch({ type: REQUEST_STARTED });
          //Call API
          const result = await post(`${config.BASE_URL}/pagoda/runQuery`, body);
          // console.log("Verification Application Deatil result", result);
          dispatch({ type: SET_REPORT, payload: result });
          dispatch({ type: REQUEST_COMPLETED });
          resolve(result);
        } catch (error:any) {
          console.log("Error", error.response);
          dispatch({ type: REQUEST_COMPLETED });
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.details
          ) {
            if (
              error.response.data.details.indexOf("No refresh token is set") !=
              -1
            ) {
              dispatch(setSessionTimeoutError(true));
            } else {
              alert(error.response.data.details);
            }
          }
          console.log("error.response.data.details", error.response);
        }
      }
    );
  };

export const runQueryCVS =
  (
    body: any,
    showProgress: boolean = true
  ): ThunkAction<void, RootState, unknown, ActionType> =>
  async (dispatch) => {
    return new Promise(
      async (resolve: (x: any) => void, reject: (x: any) => void) => {
        try {
          // console.log("showProgress", showProgress);
          dispatch({ type: REQUEST_STARTED });
          //Call API
          console.log("query:", body);
          const result = await post(`${config.BASE_URL}/cvs/runQuery`, body);
          // console.log("Verification Application Deatil result", result);
          dispatch({ type: SET_REPORT, payload: result });
          dispatch({ type: REQUEST_COMPLETED });
          resolve(result);
        } catch (error:any) {
          console.log("Error", error.response);
          dispatch({ type: REQUEST_COMPLETED });
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.details
          ) {
            if (
              error.response.data.details.indexOf("No refresh token is set") !=
              -1
            ) {
              dispatch(setSessionTimeoutError(true));
            } else {
              alert(error.response.data.details);
            }
          }
          console.log("error.response.data.details", error.response);
        }
      }
    );
  };

export const setStartDate =
  (value: any): ThunkAction<void, RootState, unknown, ActionType> =>
  async (dispatch) => {
    // console.log("Login Success");
    dispatch({
      type: SET_START_DATE,
      payload: value,
    });
  };

export const setEndDate =
  (value: any): ThunkAction<void, RootState, unknown, ActionType> =>
  async (dispatch) => {
    // console.log("Login Success");
    dispatch({
      type: SET_END_DATE,
      payload: value,
    });
  };

export const setDateRange =
  (value: any): ThunkAction<void, RootState, unknown, ActionType> =>
  async (dispatch) => {
    // console.log("Login Success");
    dispatch({
      type: SET_DATE_RANGE,
      payload: value,
    });
  };

export const setProjectName =
  (value: any): ThunkAction<void, RootState, unknown, ActionType> =>
  async (dispatch) => {
    // console.log("Login Success");
    dispatch({
      type: SET_PROJECT_NAME,
      payload: value,
    });
  };
export const setRequestStarted =
  (): ThunkAction<void, RootState, unknown, ActionType> => async (dispatch) => {
    // console.log("Login Success");
    dispatch({
      type: REQUEST_STARTED,
    });
  };

export const setRequestCompleted =
  (): ThunkAction<void, RootState, unknown, ActionType> => async (dispatch) => {
    // console.log("Login Success");
    dispatch({
      type: REQUEST_COMPLETED,
    });
  };
